module.exports = __webpack_public_path__ + "img/sort02.4f93d65f.jpg";